import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';

export type ReplyMessage =
  | {
      message?: ChatMessage | null;
      deletedMessage?: ChatMessage | null;
    }
  | null
  | undefined;

export type SetReplyMessage = (data: ReplyMessage | null) => void;

export const useReply = () => {
  const [replyMessage, setReplyMessage] = useState<ReplyMessage | null>();

  const setData = useCallback(
    (data: ReplyMessage | null) => {
      if (!data) {
        setReplyMessage(null);
        return;
      }
      const { message, deletedMessage } = data;
      const beDeleted =
        deletedMessage?.message_id &&
        replyMessage?.message?.message_id === deletedMessage.message_id;
      if (beDeleted) {
        setReplyMessage(null);
        return;
      }
      if (message) {
        setReplyMessage({ message });
      }
    },
    [replyMessage?.message?.message_id]
  );

  return {
    replyMessage,
    setReplyMessage: setData,
  };
};
